import { jsx as e } from "react/jsx-runtime";
import { isNil as a } from "es-toolkit/predicate";
import l from "../../utils/classNames.js";
const p = (o) => {
  const { showClear: s, selectedItem: t, onClear: r } = o, n = l(
    "clearButton",
    (!s || a(t)) && "hide pointer-events-none"
  );
  return /* @__PURE__ */ e("span", { className: n, onClick: r, children: /* @__PURE__ */ e("span", { className: "clearButtonIcon rioglyph rioglyph-remove-sign" }) });
};
export {
  p as default
};
//# sourceMappingURL=ClearButton.js.map
